export default __webpack_public_path__ + "static/media/img_02.6d2f42b0.jpg";